import { render, staticRenderFns } from "./search-header.vue?vue&type=template&id=6d450629&"
import script from "./search-header.vue?vue&type=script&lang=js&"
export * from "./search-header.vue?vue&type=script&lang=js&"
import style0 from "./search-header.vue?vue&type=style&index=0&id=6d450629&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports